import { HistoricalInformationSourceType } from '@core/api/angular';
import { ISelectListOption } from './shared.model';

export const HistoricalInformationSourceTypeOptions: ISelectListOption[] = [
  {
    id: HistoricalInformationSourceType.BOOK,
    label: 'Book',
  },
  {
    id: HistoricalInformationSourceType.EDITED_BOOK_SECTION,
    label: 'Edited Book Selection',
  },
  {
    id: HistoricalInformationSourceType.JOURNAL,
    label: 'Journal',
  },
  {
    id: HistoricalInformationSourceType.MANUSCRIPT,
    label: 'Manuscript',
  },
  {
    id: HistoricalInformationSourceType.ORAL,
    label: 'Oral',
  },
  {
    id: HistoricalInformationSourceType.MAP,
    label: 'Maps',
  },
  {
    id: HistoricalInformationSourceType.NEWSPAPER,
    label: 'Newspaper/Magazine',
  },
  {
    id: HistoricalInformationSourceType.ARTEFACT,
    label: 'Artefact',
  },
  {
    id: HistoricalInformationSourceType.WEBSITE,
    label: 'Website',
  },
  {
    id: HistoricalInformationSourceType.COUNCIL,
    label: 'Council',
  },
  {
    id: HistoricalInformationSourceType.OGN,
    label: 'GNV',
  },
];
